import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, sendHeartbeat, startHeartbeat } from "../lib/analytics";

/**
 * Fires a /api/analytics/pageview on every route change and keeps the
 * live-visitor heartbeat alive (30s interval while the tab is visible).
 * Mount once at the top of the routed tree.
 */
export default function usePageviewTracking() {
    const location = useLocation();
    useEffect(() => {
        startHeartbeat();
    }, []);
    useEffect(() => {
        trackPageview(location.pathname + (location.search || ""));
        sendHeartbeat(location.pathname);
    }, [location.pathname, location.search]);
}
